import React from 'react';
import { useWishes } from '../../../../../redux/reducer/content';
import useDebounce from '../../../../../hooks/shared/optimization/useDebounce';

export default function SelectedImage({ isHiddenWishCard }) {
  const { data: wishData } = useWishes();
  const debounceImage = useDebounce(wishData?.elf?.image);

  return !isHiddenWishCard && <img className={'wish__total-image'} src={debounceImage} alt={''} />;
}
